import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import { Injectable, inject } from '@angular/core';
import {select, Store} from '@ngrx/store';
import {AppState} from '../store';
import {selectAllCourses, selectInitialCoursesLoaded, selectUserPermissions} from '../store/selectors';
import {filter, first, map, tap, withLatestFrom} from 'rxjs/operators';
import {loadCourses} from '../store/course.actions';
import {CoursesDBService} from './courses-db.service';
import {Course} from '../models/course.model';
import {LoadingService} from '../shared/services/loading.service';


@Injectable()
export class ViewCoursesResolver  {
  private store = inject<Store<AppState>>(Store);
  private loading = inject(LoadingService);
  private coursesDB = inject(CoursesDBService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Course[]>{
    return this.store
      .pipe(
        select(selectInitialCoursesLoaded),
        withLatestFrom(this.store.pipe(select(selectUserPermissions))),
        tap(([initialCoursesLoaded, permissions]) => {

          if (!initialCoursesLoaded) {
            this.loading.showLoader(this.coursesDB.findAllCourses())
              .pipe(
                tap(courses => this.store.dispatch(loadCourses({courses})))
              )
              .subscribe();
          }
        }),
        map(([initialCoursesLoaded]) => initialCoursesLoaded),
        filter(initialCoursesLoaded => initialCoursesLoaded),
        withLatestFrom(this.store.pipe(select(selectAllCourses))),
        map(([initialCoursesLoaded, courses]) => courses),
        first()
      );
  }



}
